var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3V21H19V9H14C13.4477 9 13 8.55228 13 8V3H5ZM4.8 1C4.30913 1 3.84705 1.2035 3.51293 1.55155C3.18014 1.8982 3 2.35998 3 2.83333V21.1667C3 21.64 3.18014 22.1018 3.51293 22.4485C3.84705 22.7965 4.30913 23 4.8 23H19.2C19.6909 23 20.1529 22.7965 20.4871 22.4485C20.8199 22.1018 21 21.64 21 21.1667V7.83333C21 7.57518 20.9002 7.32703 20.7214 7.1408L15.1214 1.30747C14.9328 1.11104 14.6723 1 14.4 1H4.8ZM15 4.06898L17.8138 7H15V4.06898ZM12 11C12.5523 11 13 11.4477 13 12V13.25H14.25C14.8023 13.25 15.25 13.6977 15.25 14.25C15.25 14.8023 14.8023 15.25 14.25 15.25H13V16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5V15.25H9.75C9.19772 15.25 8.75 14.8023 8.75 14.25C8.75 13.6977 9.19772 13.25 9.75 13.25H11V12C11 11.4477 11.4477 11 12 11Z",
    fill: "#A81D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.e73ededade33b0102760398353fbc81e.svg";
export { ForwardRef as ReactComponent };